import coreAPIInstance from "./coreApiInstance";

export const mediaAPIs = {
  validateMediaContent: ({ payload }) => coreAPIInstance.post("/api/v1/media/validate", payload),
};
